(function (window, document) {
    'use strict';

    var triggerSelector = '[data-music-library-download-trigger]';
    var lastTrustedMouseupTrigger = null;
    var lastTrustedMouseupAt = 0;

    // The existing Download panel owns pointer/touch activation through a
    // delegated mouseup listener. Remember that path so the following click is
    // not handled twice.
    document.addEventListener('mouseup', function (event) {
        var trigger = event.target.closest(triggerSelector);

        if (!trigger || !event.isTrusted) {
            return;
        }

        lastTrustedMouseupTrigger = trigger;
        lastTrustedMouseupAt = window.performance.now();
    }, true);

    // Native button activation from Enter, Space, assistive technology, and
    // touch implementations without a compatibility mouseup still emits click.
    // Bridge only when the established panel flow has not just handled it.
    document.addEventListener('click', function (event) {
        var trigger = event.target.closest(triggerSelector);
        var followedTrustedMouseup;

        if (!trigger) {
            return;
        }

        followedTrustedMouseup = trigger === lastTrustedMouseupTrigger
            && window.performance.now() - lastTrustedMouseupAt < 500;
        lastTrustedMouseupTrigger = null;
        lastTrustedMouseupAt = 0;

        if (followedTrustedMouseup) {
            return;
        }

        trigger.dispatchEvent(new window.MouseEvent('mouseup', {
            bubbles: true,
            cancelable: true,
            view: window
        }));
    });
}(window, document));
